var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.882,
    height: 23.809,
    viewBox: "0 0 19.882 23.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_timer_1360434",
    transform: "translate(-12 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29700",
    "data-name": "Path 29700",
    d: "M12,18.365A9.941,9.941,0,1,0,22.726,8.458V6.07h4.447V4.5H16.709V6.07h4.447V8.458A9.941,9.941,0,0,0,12,18.365Zm18.312,0a8.371,8.371,0,1,1-8.371-8.371A8.371,8.371,0,0,1,30.312,18.365Z",
    transform: "translate(0 0)",
    fill: "#673695"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29701",
    "data-name": "Path 29701",
    d: "M47,33.5v7.063h6.8v-1.57H48.57V33.5Z",
    transform: "translate(-25.844 -21.414)",
    fill: "#daa520"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.e354fe501b447c00f2cc1c835025a6d5.svg";
export { ForwardRef as ReactComponent };